var App = App || {};

App.CmpBios = (function ($) {
    'use strict';

    function ModalLoad(selector) {
        const hash = window.location.hash;
        if (selector.find(hash).length == 1) {
            const modal = new bootstrap.Modal(hash);
            modal.show();
        }
    }

    return {
        ModalLoad: ModalLoad
    };

})(jQuery);